module.exports = __webpack_public_path__ + "static/apple-icon-144x144-8cf49a793cd7b63233435eca51c0e82d.png";